/* Core & libraries */
import React, { useEffect } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

/* Helpers, constants, custom methods, internal libraries */
import { useHomepageService } from '../../../services/homepageService';

/* Components */
import UCButton from '../../../components/buttons';
import travelerOnboardingCover from '../../../resources/images/traveler_onboarding_cover.jpg';

/* Styles */
import styles from './styles';

const PartnerPromotionsTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { getStaticContent, staticContent } = useHomepageService();

  // useEffect(() => {
  //   if (!staticContent?.educationalContentData) {
  //     getStaticContent();
  //   }
  // }, [staticContent]);

  // const items = staticContent?.educationalContentData?.Select || [];

  const mockupItems = [
    {
      title: "Join, dine and learn",
      description: "Enjoy exclusive dining perks and networking opportunities designed for business travelers. Earn points on every meal and turn client dinners into rewards.Earn points on every meal and turn client dinners into rewards.",
    },
    {
      title: "Enjoy live events and more",
      description: "Access live events, concerts, and entertainment through your travel rewards. Use your points to upgrade your downtime and make every trip unforgettable.",
    },
    {
      title: "Driver, save and earn",
      description: "Earn points on every car rental, airport transfer, and ground transportation. Save on your commute and turn business travel into rewards.",
    },
    {
      title: "Triple your awards this summer",
      description: "For a limited time, triple your points on every booking this summer. Book now and accelerate your way to your next reward.",
    },
    {
      title: "Your Next Reward Starts Here",
      description: "Ready to redeem your first reward? Learn how to turn your points into flights, upgrades, and hotel stays with our easy redemption guide.",
    },
    {
      title: "Get More From Every Journey",
      description: "Maximize your points on every business trip with smart booking strategies and partner perks. Get more from every journey.",
    },
    {
      title: "Save on Every Stay",
      description: "Save on every stay with exclusive hotel rates and loyalty perks. Earn points faster and enjoy premium benefits on the road.",
    },
    {
      title: "Make Every Trip Count",
      description: "Get the most value from every business trip with expert tips on earning, redeeming, and maximizing your rewards portfolio.",
    },
    {
      title: "Unlock bonus miles",
      description: "Earn and redeem airline miles faster with partner flights, upgrades, and bonus points. Unlock your next business-class reward.",
    }
  ]

  return (
    <Row className={classes.wrapper}>
      {mockupItems.map((item, idx) => (
        <Col key={idx} xs={6} md={4} xxl={3} className={classes.box}>
          <Image src={travelerOnboardingCover} fluid />
          <h3>{item.title}</h3>
          <p>{item.description}</p>
          <UCButton
            type="primary"
            className={classes.button}
            text={<FormattedMessage id="promotions.partnerPromotions.button" />}
            onClick={() => window.open("https://www.aa.com", '_blank', 'noreferrer')}
          />
        </Col>
      ))}
    </Row>
  );
};

export default PartnerPromotionsTab;
